
import { Result } from "../engine/types/result";
import { PatchworkRESTApiError, PatchworkApiError, PatchworkApiReturnCodes } from "./apireturncodes";


export async function apiRefreshToken() : Promise<Result<Response>> {
	var r = await apiPost("/api/user/refresh-token", {});
	if (r.unpack() && r.unpack()!.ok) {
		return Result.makeSuccess<Response>(r.unpack()!);
	}
	return Result.makeError<Response>(new PatchworkRESTApiError({error : "Failed to refresh token", errorCode : PatchworkApiReturnCodes.INVALIDREFRESHTOKENEXCEPTION}));
}

export function apiPost(endpoint : string, data : any, tryRefresh : boolean = false) : Promise<Result<Response>> {
	return fetch(
		endpoint,
		{
			method : "POST",
			body : JSON.stringify(data),
			headers : {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
			}
		}
	)
	.then(async (r) => {
		if (r.ok) {
			return Result.makeSuccess<Response>(r);
		}
		if (r.status === 401 && tryRefresh) {
			var refreshRes = await apiRefreshToken();
			if (refreshRes.unpack()) {
				return await apiPost(endpoint, data);
			}
			return refreshRes;
		}
		if (r.status === 400 && tryRefresh) {
			var err = new PatchworkRESTApiError((await r.clone().json()) as PatchworkApiError)
			if (err.errorCode === PatchworkApiReturnCodes.INVALIDLOGINTOKENEXCEPTION) {
				var refreshRes = await apiRefreshToken();
				if (refreshRes.unpack()) {
					return await apiPost(endpoint, data);
				}
				return refreshRes;
			}
		}
		return Result.makeSuccess<Response>(r);
	})
	.catch((err) => Result.makeError<Response>(err));
}

export function apiGet(endpoint : string, tryRefresh : boolean = false) : Promise<Result<Response>> {
	return fetch(
		endpoint,
		{
			method : "GET",
			headers : {
				'Accept' : 'application/json',
				'Content-Type' : 'application/json'
			},
		}
	)
	.then(async (r) => {
		if (r.ok) {
			return Result.makeSuccess<Response>(r);
		}
		if (r.status === 401 && tryRefresh) {
			var refreshRes = await apiRefreshToken();
			if (refreshRes.unpack()) {
				return await apiGet(endpoint);
			}
			return refreshRes;
		}
		if (r.status === 400) {
			var err = new PatchworkRESTApiError((await r.json()) as PatchworkApiError)
			if (err.errorCode === PatchworkApiReturnCodes.INVALIDLOGINTOKENEXCEPTION && tryRefresh) {
				var refreshRes = await apiRefreshToken();
				if (refreshRes.unpack()) {
					return await apiGet(endpoint);
				}
				return refreshRes;
			}
		}
		return Result.makeSuccess<Response>(r);
	})
	.catch((err) => Result.makeError<Response>(err));
}

export function apiDelete(endpoint : string, data : any, tryRefresh : boolean = false) : Promise<Result<Response>> {
	return fetch(
		endpoint,
		{
			method : "DELETE",
			body : JSON.stringify(data),
			headers : {
				'Accept' : 'application/json',
				'Content-Type' : 'application/json'
			},
		}
	)
	.then(async (r) => {
		if (r.ok) {
			return Result.makeSuccess<Response>(r);
		}
		if (r.status === 401 && tryRefresh) {
			var refreshRes = await apiRefreshToken();
			if (refreshRes.unpack()) {
				return await apiDelete(endpoint, data);
			}
			return refreshRes;
		}
		if (r.status === 400) {
			var err = new PatchworkRESTApiError((await r.json()) as PatchworkApiError)
			if (err.errorCode === PatchworkApiReturnCodes.INVALIDLOGINTOKENEXCEPTION && tryRefresh) {
				var refreshRes = await apiRefreshToken();
				if (refreshRes.unpack()) {
					return await apiDelete(endpoint, data);
				}
				return refreshRes;
			}
		}
		return Result.makeSuccess<Response>(r);
	})
	.catch((err) => Result.makeError<Response>(err));
}
